module.exports = __webpack_public_path__ + "static/media/navyTick.2585d674.svg";